var exports = {
  "zD": "visibilityLabel__xrLBQH",
  "bP": "packageIconWrapper__nPVM4f",
  "kZ": "downloadIcon__uQUfMb",
};

module.exports = exports;
